// Import model
import { ProductItemCondition } from '../models/ProductItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProductItemIndexedFields } from '../models/ProductItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProductItemIndexedFieldsSerializer } from './ProductItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProductItemCondition - handles JSON serialization and deserialization with type validation
 */
export class ProductItemConditionSerializer {
  /**
   * Deserializes a JSON string into a ProductItemCondition instance
   */
  static deserialize(json: string): ProductItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProductItemCondition instance
   */
  static fromObject(obj: any): ProductItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProductItemCondition');
    }


    const instance: ProductItemCondition = {
      fieldName: obj['fieldName'] as ProductItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProductItemCondition instances
   */
  static deserializeArray(json: string): ProductItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProductItemCondition instance to a JSON string
   */
  static serialize(instance: ProductItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProductItemCondition instance to a plain object
   */
  static toObject(instance: ProductItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProductItemCondition instances to a JSON string
   */
  static serializeArray(instances: ProductItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
